var _defs, _polygon, _polygon2, _path, _polygon3, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMozaik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Untitled-Page_201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 157.58 29.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#ffeb00;}.cls-3{fill:url(#linear-gradient-5);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.38,
    y1: 23.52,
    x2: 14.38,
    y2: -0.26,
    gradientTransform: "translate(0 26.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d8e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.58,
    y1: 23.52,
    x2: 70.58,
    y2: -0.26,
    gradientTransform: "translate(0 26.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d8e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 99.59,
    y1: 23.52,
    x2: 99.59,
    y2: -0.26,
    gradientTransform: "translate(0 26.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d8e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 122,
    y1: 23.52,
    x2: 122,
    y2: -0.26,
    gradientTransform: "translate(0 26.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d8e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -407.92,
    y1: 420.44,
    x2: -407.92,
    y2: 419.44,
    gradientTransform: "translate(64425.75 -9968.85) scale(157.58 23.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d8e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d8e3"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "10.64 26.82 10.64 15.15 14.49 19.35 18.5 15.12 18.5 26.82 28.75 26.82 28.75 3.04 18.5 3.04 14.42 7.76 10.28 3.04 0 3.04 0 26.82 10.64 26.82"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.77 26.82 82.77 20.54 72.52 20.54 83.55 3.04 58.58 3.04 58.58 8.99 68.67 8.99 57.61 26.82 82.77 26.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.64,3.04h-14.33l-8.57,23.77h10.71l1.29-4.11h7.54l1.33,4.11h10.84L106.64,3.04Zm-8.93,14.1l1.84-5.62,1.81,5.62h-3.66Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "116.63 26.82 127.37 26.82 127.37 3.04 116.63 3.04 116.63 26.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.89,26.82v-8.79c3.59,.23,5.43,3.1,5.43,8.5v.29h11.26c-.07-5.59-1.75-9.6-5.08-12.08,2.94-2.78,4.5-6.33,4.5-10.75,0-.32-.03-.61-.03-.94h-10.68c-.06,4.78-1.94,7.4-5.4,7.69V3.04h-10.64V26.82h10.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.6,29.31V0l-14.59,14.78,14.59,14.53h0ZM47,0V29.31l14.59-14.5L47,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMozaik);
export default __webpack_public_path__ + "static/media/Logo_mozaik.2141db4e71c44194ccc04827555d1039.svg";
export { ForwardRef as ReactComponent };